import Button from 'components/Button';
import ButtonGroup from 'components/ButtonGroup';
import ProgressSpinner from 'components/ProgressSpinner';
import { CallStatus } from 'messaging/calling/Call';
import { observer } from 'mobx-react';
import React from 'react';
import { CallParticipantStatus } from '../../../CallParticipant';
import { CallOperatorState, ViewMode } from '../../../constants';
import styles from './CallPromptActions.m.sass';

/**
 " Call Actions
 */
export var CallPromptActions = observer(function CallPromptActions(_ref) {
  var vm = _ref.callViewModel;
  if (vm.call.callStatus !== CallStatus.InProgress) {
    return /*#__PURE__*/React.createElement(JoinedReport, {
      callViewModel: vm
    });
  }
  switch (vm.state) {
    case CallOperatorState.Inactive:
      {
        return /*#__PURE__*/React.createElement("div", {
          className: styles.actions
        }, /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement(Button, {
          loading: vm.join.pending,
          disabled: vm.join.pending,
          type: "primary",
          onClick: vm.join,
          "data-test": "join-call"
        }, "Join")));
      }
    case CallOperatorState.Incoming:
      return /*#__PURE__*/React.createElement("div", {
        className: styles.actions
      }, /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement(Button, {
        onClick: vm.decline,
        "data-test": "decline-call"
      }, "Decline"), /*#__PURE__*/React.createElement(Button, {
        type: "primary",
        onClick: vm.join,
        "data-test": "accept-call"
      }, "Accept")));
    case CallOperatorState.Connecting:
      return /*#__PURE__*/React.createElement("div", {
        className: styles.actions
      }, /*#__PURE__*/React.createElement(ProgressSpinner, {
        size: 16,
        thickness: 2
      }));
    case CallOperatorState.Connected:
      return /*#__PURE__*/React.createElement("div", {
        className: styles.actions
      }, /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement(Button, {
        type: "danger",
        onClick: vm.hangup
      }, "Hang up"), vm.viewMode === ViewMode.Hidden ? /*#__PURE__*/React.createElement(Button, {
        onClick: vm.revealCallContext
      }, "Show") : /*#__PURE__*/React.createElement(Button, {
        onClick: vm.hide
      }, "Hide")));
  }
});

/**
 " Joined Report.
 * WARNING: Here be dragons.
 */
export var JoinedReport = observer(function JoinedReport(_ref2) {
  var vm = _ref2.callViewModel;
  var result = '';
  var joined = vm.call.participants.filter(function (p) {
    return p.status === CallParticipantStatus.Disconnected;
  });
  var missed = vm.call.participants.filter(function (p) {
    return p.status === CallParticipantStatus.Missed;
  });
  var declined = vm.call.participants.filter(function (p) {
    return p.status === CallParticipantStatus.Declined;
  });
  var joinedCount = joined.length;
  // If everyone is `Disconnected` then everyone joined.
  if (joinedCount === vm.call.participants.length) {
    if (joinedCount === 2 && joined.some(function (p) {
      return p.member.isCurrentUser;
    })) {
      result = 'You both joined';
    } else {
      result = 'Everyone joined';
    }
  } else {
    // Don't include ourselves for the Joined segment.
    var otherJoined = joined.filter(function (p) {
      return p.member.isCurrentUser === false;
    });
    result = [otherJoined.length > 1 && "".concat(toPeople(otherJoined), " joined"), missed.length > 0 && "".concat(toPeople(missed), " missed the call"), declined.length > 0 && "".concat(toPeople(declined), " declined the call")].filter(Boolean).join('. ') + '.';
  }
  var tooltip = ("Joined: ".concat(joined.map(function (p) {
    return p.member.displayName;
  }).join(', '), "\n\n") + (declined.length > 0 ? "Declined: ".concat(declined.map(function (p) {
    return p.member.displayName;
  }).join(', '), "\n\n") : '') + (missed.length > 0 ? "Missed: ".concat(missed.map(function (p) {
    return p.member.displayName;
  }).join(', ')) : '')).trim();
  return /*#__PURE__*/React.createElement("div", {
    className: styles.joinedReport,
    title: tooltip
  }, result);
});

/**
 * Returns the display name of the only participant in the list,
 * or the total count if the count is not exactly 1.
 * @param {CallParticipant[]} callParticipantList
 */
function toPeople(callParticipantList) {
  if (callParticipantList.length !== 1) {
    return "".concat(callParticipantList.length.toString(), " people");
  } else {
    var member = callParticipantList[0].member;
    return member.isCurrentUser ? 'You' : member.displayName;
  }
}
//# sourceMappingURL=index.js.map
